import React from "react";
import DateFormatter from "../../modules/utils/DateFormatter";
import { Line } from "react-chartjs-2";

import _forEach from "lodash/forEach";
import _find from "lodash/find";
import _groupBy from "lodash/groupBy";
import _get from "lodash/get";
import _assign from "lodash/assign";
import colors from "styles/colors";
import formatMetricValue from "../../modules/utils/formatMetricValue";
import formatNumber from "../../modules/utils/formatNumber";
import trendingToolTip from "./TrendingToolTip";
import "styles/Trending.css";

export const TrendingLineGraph = ({ setTooltip, dataList, metric, labels }) => {
  const values = [];

  dataList.map((item) => {
    values.push(item.value);
  });

  const maxVal = Math.max(...values);

  let stepSize = maxVal < 1 ? maxVal / 4 : Math.ceil(parseInt(maxVal / 4));

  if (stepSize < 1) {
    stepSize = 1;
  }

  const data = (canvas) => {
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 200);
    gradient.addColorStop(0, colors.trendingFull);
    gradient.addColorStop(1, colors.trendingBlank);
    return {
      labels,
      datasets: [
        {
          label: "",
          fill: true,
          lineTension: 0.1,
          backgroundColor: gradient,
          borderWidth: 2,
          borderColor: colors.primary,
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          data: values,
        },
      ],
      tooltips: {
        enabled: false,
      },
    };
  };
  return (
    <Line
      data={data}
      options={{
        layout: {
          padding: {
            top: 20,
          },
        },
        tooltips: {
          xPadding: 0,
          yPadding: 0,
          enabled: false,
          custom: (tooltipModel) => {
            trendingToolTip(tooltipModel, setTooltip, metric);
          },
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                fontColor: colors.primary,
                fontSize: 10,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                drawBorder: false,
                color: colors.sectionLine,
                zeroLineColor: colors.sectionLine,
              },
              ticks: {
                beginAtZero: true,
                stepSize: stepSize,
                fontColor: colors.primary,
                callback: (value) =>
                  metric === "ctr" && maxVal < 1 ? formatNumber(value, 3) : formatMetricValue("conversions", value),
                fontSize: 10,
              },
            },
          ],
        },
        maintainAspectRatio: false,
      }}
    />
  );
};

export const initGraphLabel = (dataList, metric, selectedViewValue) => {
  let labelDateTemp = [];
  let formatDateMonth = DateFormatter.formatDateMonth;
  let formatDelDate = DateFormatter.formatDelOneDay;
  let formatOneWeek = DateFormatter.formatOneWeek;
  const findDataKey = dataList[metric];

  if (findDataKey.data[0] != undefined) {
    let start_date = findDataKey.data[0].date.split("-");
    let start_year = start_date[0];
    let start_month = start_date[1];
    let start_day = start_date[2];
    let getDate = new Date(start_year, start_month, 0).getDate();

    const dateNow = new Date();
    let getDayDateNow = dateNow.getDate();

    let get_last_30d = dateNow - 30;
    let get_date_last_30d = new Date(get_last_30d).getDate();

    if (selectedViewValue) {
      switch (selectedViewValue.key) {
        case "today":
        case "yesterday":
          const firstDay = dateNow;
          labelDateTemp.push(formatDateMonth(firstDay));

          for (let i = getDayDateNow - 5; i <= getDayDateNow; i++) {
            const day = formatDelDate(dateNow);
            labelDateTemp.push(formatDateMonth(day));

            if (i === getDayDateNow) {
              labelDateTemp.reverse();
            }
          }

          break;
        case "last_7d":
          for (let i = getDayDateNow - 7; i <= getDayDateNow; i++) {
            if (i === getDayDateNow) {
              labelDateTemp.reverse();
            } else {
              const yesterday = formatDelDate(dateNow);
              labelDateTemp.push(formatDateMonth(yesterday));
            }
          }
          break;
        case "last_week_mon_sun":
          // get the first day of last week that start from monday
          let today = new Date();
          let thisMonday = new Date(today.setDate(today.getDate() - today.getDay() + 1));
          let lastMonday = new Date(thisMonday.setDate(thisMonday.getDate() - 7));
          labelDateTemp.push(formatDateMonth(lastMonday));
          for (let i = 0; i < 6; i++) {
            // add i days to last monday
            lastMonday.setDate(lastMonday.getDate() + 1);
            labelDateTemp.push(formatDateMonth(lastMonday));
          }
          break;
        case "last_30d":
          for (let i = getDayDateNow - 30; i <= getDayDateNow; i++) {
            if (i == getDayDateNow) {
              labelDateTemp.reverse();
            } else {
              const yesterday = formatDelDate(dateNow);
              labelDateTemp.push(formatDateMonth(yesterday));
            }
          }
          break;
        case "last_month":
          getDate = new Date(start_year, start_month, 0).getDate();
          for (let i = getDate - 30; i <= getDate; i++) {
            if (i == 0) {
              //skip
            } else {
              const yesterday = formatDateMonth(new Date(start_year, start_month - 1, i));
              labelDateTemp.push(yesterday);
            }
          }
          break;
      }
    }
  }

  return labelDateTemp;
};

export const initGraphData = (dataList, metric, labelDate, selectedViewValue) => {
  let newDataListTemp = [];
  let insertedData = false;
  let formatDateMonth = DateFormatter.formatDateMonth;
  const findDataKey = dataList[metric];
  const chartDataList = [];

  if (findDataKey?.data.length > 0) {
    _forEach(findDataKey?.data, function (data) {
      let slotDate = data.date.split("-");

      const numbver = data.conversions < 0.1 ? data.conversions.toPrecision(1) : data.conversions;
      chartDataList.push({
        value: numbver,
        label: formatDateMonth(data.date),
      });
    });
  }

  labelDate.map((ele_ld) => {
    insertedData = false;

    chartDataList.map((data) => {
      if (ele_ld === data.label) {
        newDataListTemp.push({
          value: data.value,
          label: ele_ld,
        });

        insertedData = true;
      } else if (["today", "yesterday"].includes(selectedViewValue.key)) {
        newDataListTemp.push({
          value: null,
          label: ele_ld,
        });
      }
    });

    if (insertedData !== true && !["today", "yesterday"].includes(selectedViewValue.key)) {
      newDataListTemp.push({
        value: 0,
        label: ele_ld,
      });
    }
  });

  return newDataListTemp;
};
